import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Copy, MessageCircle, Share2 } from "lucide-react";
import { SERIF } from "../soulumoPractice/practiceApi";
import { TogetherRhythm } from "./TogetherRhythm";
import { TogetherQr } from "./TogetherQr";

// After Create Invitation: the same share options as a gift (phone share sheet, WhatsApp, copy).
export const TogetherShare = ({ made, title }) => {
  const nav = useNavigate();
  const [done, setDone] = useState("");
  const link = `${window.location.origin}${made.url}`;
  const text = `I've chosen "${title}" for us. Would you like to do the next 21 days together?`;
  const share = async () => {
    if (navigator.share) { try { await navigator.share({ title: "21 Days Together", text, url: link }); setDone("Sent"); } catch { /* closed */ } }
    else window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(`${text}\n${link}`)}`, "_blank");
  };
  const copy = async () => { try { await navigator.clipboard.writeText(link); setDone("Link copied"); } catch { setDone(link); } };
  const btn = "rounded-full py-3 inline-flex items-center justify-center gap-2 text-sm border border-[#d7bb7a]/50 text-[#d7bb7a] transition-colors hover:bg-[#d7bb7a]/10";
  return (
    <section className="mt-10 rounded-3xl border border-[#d7bb7a]/30 bg-[#10213f] p-6" data-testid="together-share">
      <h2 className="text-2xl text-[#f3ecd9]" style={{ fontFamily: SERIF }}>Your invitation is ready</h2>
      <p className="mt-2 text-sm text-[#cfc6ae]">Share this link with one person or with many. Everyone who joins follows the same start date and rhythm in their own planner. Your own 21 days are now in your library.</p>
      <TogetherRhythm intensity={made.invite.intensity} night={made.invite.night} day={made.invite.day} />
      <TogetherQr link={link} title={title} invite={made.invite} />
      <button type="button" onClick={share} data-testid="together-share-send"
        className="mt-5 w-full rounded-full bg-[#d7bb7a] py-3.5 inline-flex items-center justify-center gap-2 text-sm uppercase tracking-[0.2em] text-[#0b1a33]"><Share2 size={15} /> Share invitation</button>
      <div className="mt-3 grid grid-cols-2 gap-3">
        <button type="button" className={btn} data-testid="together-share-whatsapp" onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(`${text}\n${link}`)}`, "_blank")}><MessageCircle size={15} /> WhatsApp</button>
        <button type="button" className={btn} onClick={copy} data-testid="together-share-copy"><Copy size={15} /> Copy link</button>
      </div>
      {done && <p className="mt-3 break-all text-center text-xs text-[#b9ad8f]" data-testid="together-share-done">{done}</p>}
      <button type="button" onClick={() => nav("/my-library")} className="mt-6 w-full text-xs text-[#b9ad8f] underline-offset-4 hover:text-[#f3ecd9] hover:underline" data-testid="together-open-library">Open my library</button>
    </section>
  );
};
